import cornerstoneWADOImageLoader from "cornerstone-wado-image-loader";
import * as redactionStore from "../redaction/redaction-store";

/**
 * Thin wrapper over WADO's own loader for the `wadouri:` / `dicomweb:` schemes,
 * adding the one thing it doesn't do: apply committed redactions to the decoded
 * frame.
 *
 * DICOMweb imports have no local file to fall back on, so their frames are simply
 * re-fetched when the image cache evicts them. That's always been true — but it
 * also meant an evicted redacted frame came back from the server unredacted, since
 * the old design only wrote redacted pixels back for the `dicomfile:` scheme.
 * Applying redaction at decode time fixes that for every source uniformly.
 *
 * Everything else about the load object (cancelFn, decache) passes straight
 * through, so WADO's own dataSet refcounting is untouched.
 */
const wadoLoader = cornerstoneWADOImageLoader as any;

export default function wadouriRedactLoader(imageId: string, options: any) {
  const loadObject = wadoLoader.wadouri.loadImage(imageId, options);

  return {
    ...loadObject,
    promise: loadObject.promise.then((image: any) => {
      redactionStore.applyTo(image);
      return image;
    }),
  };
}
